import { render, staticRenderFns } from "./AppliedWarranty.vue?vue&type=template&id=4f2620ff"
import script from "./AppliedWarranty.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppliedWarranty.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppliedWarranty.vue?vue&type=style&index=0&id=4f2620ff&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports